// extracted by mini-css-extract-plugin
module.exports = {"maxMobile":"767px","minTablet":"768px","maxTablet":"1024px","minDesktop":"1025px"};